import type { ComponentType } from 'react';
import { ShieldCheck, FlaskConical, Activity, FileSearch } from 'lucide-react';

/**
 * The four Build-console "Validate" pages, surfaced from the capture Docs page
 * as a group pinned under Requirements/Design.
 *
 * The pages themselves stay on the Build console — they drive Build flows (the
 * Learn loop, guardrail records, repo-role settings) that only exist there — so
 * these entries link across to `{slug}.build.systemdox.com` rather than
 * rendering on the capture surface. `path` is the route on the Build console.
 */
export interface ValidateSection {
  key: string;
  label: string;
  /** Route on the Build console (reached cross-host from the capture Docs page). */
  path: string;
  icon: ComponentType<{ className?: string }>;
  description: string;
  /** Home-card icon tile background/foreground. */
  cardIconBg: string;
  cardIconColor: string;
}

export const VALIDATE_SECTIONS: ValidateSection[] = [
  {
    key: 'fitness',
    label: 'Architecture Fitness',
    path: '/verify/fitness',
    icon: ShieldCheck,
    description: 'Fitness test compliance across repositories — see which checks pass or fail on each repo.',
    cardIconBg: 'bg-amber-100 dark:bg-amber-900/30',
    cardIconColor: 'text-amber-600 dark:text-amber-400',
  },
  {
    key: 'tests',
    label: 'Test Reports',
    path: '/verify/tests',
    icon: FlaskConical,
    description: 'Integration test results across services with pass/fail status, duration, and regression detection.',
    cardIconBg: 'bg-emerald-100 dark:bg-emerald-900/30',
    cardIconColor: 'text-emerald-600 dark:text-emerald-400',
  },
  {
    key: 'ci',
    label: 'CI/CD Status',
    path: '/verify/ci',
    icon: Activity,
    description: 'Real-time GitHub Actions workflow status across all connected repositories.',
    cardIconBg: 'bg-blue-100 dark:bg-blue-900/30',
    cardIconColor: 'text-blue-600 dark:text-blue-400',
  },
  {
    key: 'apis',
    label: 'API Contracts',
    path: '/verify/apis',
    icon: FileSearch,
    description: 'Browse OpenAPI specs and detect drift between deployed APIs and repository definitions.',
    cardIconBg: 'bg-purple-100 dark:bg-purple-900/30',
    cardIconColor: 'text-purple-600 dark:text-purple-400',
  },
];
